import React, { useEffect, useState } from "react";
import styles from "./rentRollPrintView.module.css"
import dayjs from "dayjs";

const RentRollPrintView = React.forwardRef(({ rentRollData, rentList, propertyDetails }, ref) => {
    const currency = (value) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(value);

    const [totalBill, setTotalBill] = useState(0);
    const [totalDeposit, setTotalDeposit] = useState(0);
    const [totalLateFees, setTotalLateFees] = useState(0);

    useEffect(() => {
        let totalBillTemp = 0;
        let totalDepositTemp = 0;
        let totalLateFeeTemp = 0;

        rentList?.forEach(item => {
            if (item?.type === 1) {
                totalBillTemp += parseFloat(item?.amount);
                if (item?.payment_type === 'late-fee') {
                    totalLateFeeTemp += parseFloat(item?.paid_amount);
                }
            }
            if (item?.type === 2) {
                totalDepositTemp += parseFloat(item?.amount);
            }
        });

        setTotalBill(totalBillTemp);
        setTotalDeposit(totalDepositTemp);
        setTotalLateFees(totalLateFeeTemp);
    }, [rentList]);

    return (<div ref={ref} className={`${styles.printWrapper}`}>
        <div className={`${styles.PrintMainsec}`}>
            <div className={`${styles.HeadLogoSec}`}>
                <img src={propertyDetails?.app_theme_options && propertyDetails?.app_theme_options?.image_url && propertyDetails?.app_theme_options?.image_url !== "" ? propertyDetails?.app_theme_options?.image_url : "/static/img/logo-icon.png"} alt="" />
                <p className={`${styles.Address}`}>{propertyDetails?.fulladdress}</p>
            </div>
            <p className={`${styles.ReportTitle}`}>Tenant Ledger Report</p>
            <div className={`${styles.CustomerDetailsSec}`}>
                <p style={{ backgroundColor: '#ebe7ef' }}>
                    <span>Tenant Name:</span>
                    {rentRollData?.tenant_name}
                </p>
                <p>
                    <span>Unit:</span>
                    {rentRollData?.property_name} #{rentRollData?.apt_name}
                </p>
                <p>
                    <span>Lease Period:</span>
                    {rentRollData?.lease_term}
                </p>
                <p>
                    <span>Report Date:</span>
                    {dayjs().format('MMM D, YYYY')}
                </p>
            </div>
            <div className={`${styles.SummerSec}`}>
                <p className={`${styles.Title}`}>Account Summary</p>
                <table>
                    <tr>
                        <th>Description</th>
                        <th className={`${styles.TextAlignRight}`}>Amount</th>
                    </tr>
                    <tr>
                        <td>Total Charges</td>
                        <td className={`${styles.TextAlignRight}`}>{currency(totalBill)}</td>
                    </tr>
                    <tr>
                        <td>Total Payments</td>
                        <td className={`${styles.TextAlignRight}`}>({currency(totalDeposit)})</td>
                    </tr>
                    <tr>
                        <td>Late Fees</td>
                        <td className={`${styles.TextAlignRight}`}>{currency(totalLateFees)}</td>
                    </tr>
                    <tr>
                        <td>Outstanding Balance</td>
                        <td className={`${styles.TextAlignRight}`}>{currency(totalBill - totalDeposit)}</td>
                    </tr>
                </table>
            </div>
            <div className={`${styles.SummerSec}`}>
                <p className={`${styles.Title}`}>Transaction Details</p>
                <table>
                    <tr>
                        <th>Date</th>
                        <th>Description</th>
                        <th>Charge ($)</th>
                        <th>Payment ($)</th>
                        <th className={`${styles.TextAlignRight}`}>Balance ($)</th>
                    </tr>
                    {rentList?.map(item => {
                        return (<tr>
                            <td>{dayjs(item?.date).format('MM/DD/YYYY')}</td>
                            <td>{item?.description}</td>
                            <td>{item?.type === 1 ? new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(item?.amount) : ''}</td>
                            <td>{item?.type === 2 ? new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(item?.amount) : ''}</td>
                            <td className={`${styles.TextAlignRight}`}>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(item?.balance_new)}</td>
                        </tr>)
                    })}
                </table>
            </div>
            <p className={`${styles.FooterText}`}>Balances reflect all payments received and processed as of the report date. If you notice a discrepancy, please contact the leasing office.</p>
            <div className={`${styles.FooterLogoSec}`}><img src={"/static/img/logo.png"} alt="" className={`${styles.FooterLogo}`} /></div>
        </div>
    </div>);
});

export default RentRollPrintView;